// extracted by mini-css-extract-plugin
export default {"title":"Testimonials2_title__M0oJJ","testimonial":"Testimonials2_testimonial__QRtCW","overview":"Testimonials2_overview__ty8gH"};